import { mixins, HorizontalBar } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
//import { debug } from 'util';

const { reactiveProp } = mixins

export default {
    name: 'bar-chart-horizontal',
    extends: HorizontalBar,
    plugins: [ChartDataLabels],
    mixins: [reactiveProp],
    props: {
        extraOptions: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        let newSize = Math.round(1.3 * (window.innerHeight) / 100);
        //let barThickness = Math.round(1.9 * (window.innerHeight) / 100);
        
        return {
            ctx: null,
            options: {
                //tooltips: {
                //    callbacks: {
                //        title: function (tooltipItems) {
                //            //Return value for title
                //            return tooltipItems[0].yLabel.toString().replaceAll(',', ' ');
                //        },
                //    }
                //},
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        fontColor: '#005582',
                        fontSize: newSize,
                        fontFamily: 'Roboto, sans-serif'
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            //categoryPercentage: 0.5,
                            //barPercentage: 0.2,
                            //barThickness: 5,
                            //maxBarThickness: 5,
                            ticks: {
                                beginAtZero: true,
                                min: 0,
                                max: 100,
                                stepSize: 10,
                                fontSize: newSize,
                                fontFamily: 'Roboto, sans-serif'
                            }
                        }
                    ],
                    yAxes: [
                          {
                            //barPercentage: 0.1,
                            //categoryPercentage: 0.5,
                            //barThickness: 'flex',
                            //barThickness: 13,
                           // maxBarThickness: 17,
                            ticks: {
                                fontSize: newSize,
                                fontFamily: 'Roboto, sans-serif'
                            }

                        }
                    ]
                }
            }
        };
    },
    mounted() {
        this.$watch(
            'chartData',
            (newVal, oldVal) => {
                if (!oldVal) {
                    //debugger;
                    //console.log('not of oldval');
                    //console.log(this.chartData);
                    //let noOfCategories = this.chartData.labels.length;
                    //let categoryPercentage = noOfCategories / 10;
                    //if (categoryPercentage < 0.9) {
                    //    categoryPercentage = categoryPercentage + 0.1;
                    //}
                    //console.log(categoryPercentage);
                    //this.options.scales.yAxes.categoryPercentage = categoryPercentage;
                    this.renderChart(this.chartData, this.options);
                }
            },
            { immediate: true }
        )
    }
};
